import { WorkflowEditDialogMessages } from "@/messages/workflow/workflow-edit-dialog.messages";
import { TabItem } from "@/types/form.types";

import { WorkflowStepFormTabs } from "./types";

export const STEP_FORM_TABS_ITEMS = (
  messages: WorkflowEditDialogMessages
): TabItem<WorkflowStepFormTabs>[] => [
  { value: "inputTab", label: messages.stepFormTabInputLabel },
  { value: "processingTab", label: messages.stepFormTabProcessingLabel },
  { value: "outputTab", label: messages.stepFormTabOutputLabel },
];
